<template>
  <div class="settlement-counters">
    <div v-for="item in items" :key="item.status" class="counter">
      <img :src="item.icon" :alt="item.label" class="icon" />
      <span class="label" :style="{ color: item.color }">{{ item.label }}</span>
      <span class="value">{{ item.value }}</span>
    </div>
  </div>
</template>

<script>
import { SETTLEMENT_STATUS_META } from "./statusMeta";

const ORDER = ["NIEROZLICZONO", "W_TRAKCIE", "DO_WERYFIKACJI", "DO_POPRAWY", "ROZLICZONO"];

export default {
  name: "SettlementStatusCounters",
  props: {
    counters: { type: Object, default: null },
  },
  computed: {
    items() {
      return ORDER.map((status) => {
        const meta = SETTLEMENT_STATUS_META[status];
        const raw = this.counters ? this.counters[status] : 0;
        return {
          status,
          label: meta.label,
          color: meta.color,
          icon: meta.icon,
          value: Number.isFinite(Number(raw)) ? Number(raw) : 0,
        };
      });
    },
  },
};
</script>

<style scoped>
.settlement-counters {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  background: #fff;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.counter {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 700;
  font-size: calc(12px + 0.1vw);
  text-transform: uppercase;
}
.icon {
  width: 1.4rem;
  height: 1.4rem;
}
.value {
  color: #1f1f3d;
  margin-left: 0.25rem;
}
</style>
